/* v3-faq.js: the FAQs page. Builds the jump index from the bands on the page, filters every question as you
   type, and opens an answer linked to by hash (#faq-cancelling-my-order) or by ?q=. Loaded by v3-faq-hero.
   Progressive enhancement: the search field and the index are rendered hidden and only revealed here, so with
   no JavaScript the page is the full, readable list. No globals of its own; reads window.v3 from v3-core.js. */
(function () {
  'use strict';

  var page = document.querySelector('[data-v3-faq-page]');
  var groups = Array.prototype.slice.call(document.querySelectorAll('[data-v3-faq-group]'));
  if (!page || !groups.length) return;

  var form = page.querySelector('[data-v3-faq-form]');
  var input = page.querySelector('[data-v3-faq-search]');
  var clearBtn = page.querySelector('[data-v3-faq-clear]');
  var indexEl = page.querySelector('[data-v3-faq-index]');
  var statusEl = page.querySelector('[data-v3-faq-status]');
  var emptyEl = page.querySelector('[data-v3-faq-empty]');
  var v3 = window.v3;

  function normalise(s) {
    return (s || '').toLowerCase().replace(/[‘’]/g, "'").replace(/\s+/g, ' ').trim();
  }

  /* ---------- read the page ------------------------------------------- */
  var bands = groups.map(function (group) {
    var rows = Array.prototype.slice.call(group.querySelectorAll('.v3-acc')).map(function (el) {
      return { el: el, text: normalise(el.textContent) };
    });
    return {
      el: group,
      id: group.id,
      title: group.getAttribute('data-v3-faq-title') || '',
      rows: rows,
      link: null,
      count: null
    };
  }).filter(function (band) { return band.rows.length > 0; });

  if (!bands.length) return;

  /* ---------- jump index ----------------------------------------------- */
  if (indexEl) {
    var entries = bands.map(function (band) { return { id: band.id, label: band.title, count: band.rows.length, band: band }; });
    v3.buildIndex(indexEl, entries, {
      linkClass: 'v3-faqindex__link',
      countClass: 'v3-faqindex__count',
      onClick: function (entry, e) { e.preventDefault(); go(entry.band.el); }
    }).forEach(function (built) { built.entry.band.link = built.link; built.entry.band.count = built.count; });
    if (indexEl.children.length) indexEl.hidden = false;
  }

  function go(el) {
    el.scrollIntoView({ behavior: v3.reduceMotion ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState && el.id) history.replaceState(null, '', '#' + el.id);
  }

  /* ---------- filter ---------------------------------------------------- */
  function template(name, fallback) {
    return (statusEl && statusEl.getAttribute('data-' + name)) || fallback;
  }

  function say(count, terms) {
    if (!statusEl) return;
    if (!terms) { statusEl.hidden = true; statusEl.textContent = ''; return; }
    var copy = count === 0
      ? template('none', 'No answers for “[terms]”')
      : count === 1
        ? template('one', '1 answer for “[terms]”')
        : template('many', '[count] answers for “[terms]”');
    statusEl.textContent = copy.replace('[count]', count).replace('[terms]', terms);
    statusEl.hidden = false;
  }

  function apply(raw) {
    var query = normalise(raw);
    var tokens = query ? query.split(' ') : [];
    var total = 0;

    bands.forEach(function (band) {
      var hits = 0;
      band.rows.forEach(function (row) {
        var hit = !tokens.length || tokens.every(function (t) { return row.text.indexOf(t) > -1; });
        row.el.hidden = !hit;
        if (hit) hits++;
        if (tokens.length && hit && !row.el.open) {
          row.el.open = true;
          row.el.setAttribute('data-v3-faq-auto', '');
        } else if (!tokens.length && row.el.hasAttribute('data-v3-faq-auto')) {
          row.el.open = false;
          row.el.removeAttribute('data-v3-faq-auto');
        }
      });
      band.el.hidden = tokens.length > 0 && hits === 0;
      if (band.link) band.link.hidden = band.el.hidden;
      if (band.count) band.count.textContent = hits;
      total += hits;
    });

    if (clearBtn) clearBtn.hidden = !tokens.length;
    if (emptyEl) emptyEl.hidden = !(tokens.length && total === 0);
    say(total, tokens.length ? raw.trim() : '');
  }

  /* ---------- wire the field -------------------------------------------- */
  if (form && input) {
    form.hidden = false;
    v3.filterField({ input: input, form: form, clear: clearBtn, apply: apply });
  }

  /* ---------- deep links ------------------------------------------------- */
  function openHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var target;
    try { target = document.querySelector(hash); } catch (e) { return; }
    if (!target) return;
    var row = target.closest ? target.closest('.v3-acc') : null;
    if (row) {
      row.open = true;
      row.hidden = false;
      if (row.parentElement) {
        var band = row.closest('[data-v3-faq-group]');
        if (band) band.hidden = false;
      }
    }
    (row || target).scrollIntoView({ behavior: 'auto', block: 'start' });
  }

  window.addEventListener('hashchange', openHash);

  /* ---------- start ------------------------------------------------------- */
  var initial = '';
  try {
    initial = new URLSearchParams(window.location.search).get('q') || '';
  } catch (e) { initial = ''; }

  if (initial && input) {
    input.value = initial;
    apply(initial);
  } else {
    apply('');
  }
  openHash();
})();
